import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import s from './kaltura.sss';
import { joinClasses } from 'utils/utils';

export default class Kaltura extends Component {
	componentDidMount() {
		Store.emit(actions.KALTURA_VIDEO, true);
		Store.emit('ENSIGHTEN_VIDEO_PLAY', { videoTitle: this.props?.data?.name });
	}

	componentWillUnmount() {
		Store.emit(actions.KALTURA_VIDEO, false);
	}

	render({ src, onVideoPage, length }) {
		const fullScreen = length === 1;
		return (
			<div class={joinClasses({ s, container: true, keepAspectRatio: !onVideoPage, onVideoPage, fullScreen })}>
				<iframe id="kaltura_player" src={src} allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation" frameborder="0" title="Kaltura Player" />
			</div>
		);
	}
}
